require("./_vendor/_mmaw.js");

require("./_layout/_commons.js");

require("./matomo/matomo.js");
require("./_layout/_header.js");
require("./_layout/_footer.js");
require("./_components/_language_switcher.js");
require("./_components/_accessibility_buttons.js");
// require("./cad/jquery-1.6.4.js");
// require("./cad/jquery.signalR.js");
// require("./cad/server.js");



// example of using ts file =>
// const helloWorld = require("./_test.ts").helloWorld();

// console.log(helloWorld);
